import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { SuperNet } from '../models/supernet';

@Injectable()
export class SuperNetService {

  private urlEndPoint: string = environment.superNetEndPoint;

  constructor(private http: HttpClient) { }

  listarSuperNet(): Observable<SuperNet[]> {
    return this.http.get(this.urlEndPoint + 'listar').pipe(
      map((response) => response as SuperNet[]),
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/supernet.service.ts